import { colors } from '../..'
import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const LargeVisions: Dashboard = {
    id: 'LARGEVISION',
    name: 'Large-Vision',
    daterange: true,
    metrics: [
        {
            type: Metrics.LARGEVISION_DEVICES_ONLINE,
            'box-size': BoxSizes.MID,
            chart: Chart.Doughnut,
            count: 'dashboard-count-devices',
            title: 'dashboard-devices-online',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.BIG,
            metrics: [
                {
                    type: Metrics.LARGEVISION_DWELLTIMELINE,
                    'box-size': BoxSizes.FULLWIDTH,
                    chart: Chart.Timeline,
                    color: [colors.bluelight, colors.orange, '#bb5ee0', '#56bbc5'],
                    legend: true,
                    title: 'dashboard-dwelltimeline',
                    count: 'dashboard-count-seconds-average',
                },
                {
                    type: Metrics.LARGEVISION_SESSIONS_TIMELINE,
                    'box-size': BoxSizes.FULLWIDTH,
                    chart: Chart.Timeline,
                    color: [colors.bluelight, colors.orange, '#bb5ee0', '#56bbc5'],
                    legend: true,
                    title: 'dashboard-sessions-timeline',
                    count: 'dashboard-count-sessions-average',
                },
            ],
        },
        {
            type: Metrics.LARGEVISION_STORES_TOP,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-stores-top',
            count: 'dashboard-count-stores',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.LARGEVISION_INTERACTIONS_PLAYLISTS,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-interactions-playlists',
            count: 'dashboard-count-playlists',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.LARGEVISION_INTERACTIONS_PRODUCTS,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-interactions-products',
            count: 'dashboard-count-products',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.MID,
            metrics: [
                {
                    type: Metrics.LARGEVISION_INTERACTIONS_TOTAL,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-interactions-total',
                },
                {
                    type: Metrics.LARGEVISION_PLAYLIST_TOP,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-playlists-top',
                },
            ],
        },
    ],
}

export default LargeVisions
